import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import * as Tools from "../../helpers/Tools";
import * as types from "../../constants/actionTypes";
import { logUI } from "../../api/andyliticsApi";
import SchedulingQuestions from './SchedulingQuestions';
import OverviewConfirmation from './OverviewConfirmation';
import StickyProgressBar from '../common/StickyProgressBar';
import Spinner from '../common/spinner';
import { Grid, Typography, Icon, Notifier } from "../ecosystem/";
import * as msgs from "../../constants/textConstants";


const InHomeWhatsNext = ({ history, bookApptResult, bookAppointment, pending, screenBreakPoint }) => {
    const [isBookingSuccess, setIsBookingSuccess] = useState(history.location.state?.isBookingSuccess);

    useEffect(() => {
        if (bookApptResult && bookApptResult.success) {
            if (!isBookingSuccess) {
                setIsBookingSuccess(true);
            }
            logUI(`MBHWeb.UI.InHomeSchedulingConfirmation.Success.Displayed`, new Date(), Tools.getURLPath());
        } else {
            logUI(`MBHWeb.UI.InHomeSchedulingConfirmation.Failed.Displayed`, new Date(), Tools.getURLPath());
        }
    }, [bookApptResult]);

    const rebookAppt = () => {
        logUI(`MBHWeb.UI.InHomeSchedulingConfirmation.TryAgain.Clicked`, new Date(), Tools.getURLPath());
        bookAppointment();
    }

    const isMobileSize = (screenBreakPoint === msgs.XS_MOBILE || screenBreakPoint === msgs.SM_MOBILE || screenBreakPoint === msgs.MD_TABLET) ? true : false;

    return (
        <>
            {!bookApptResult ? <Redirect to="/inhomeschedule/s7" /> : 
                <>
                    {isBookingSuccess && <StickyProgressBar className="inhome" />}
                    <Grid className="body-content body-content--no-top-offset body-content--no-footer inhome inhome-scheduling inhome-scheduling-container appointment-confirmation-container">
                        <div className="row">
                            <div className="col-12 maxWidth-content">
                                {isBookingSuccess
                                    ? <>
                                        <div className="row whats-next-overview-container">
                                            <div className="col whats-next-overview-container__icon">
                                                <Icon name="check" color={"$color-system-a1"} size={`${isMobileSize ? 'medium' : 'xlarge'}`} />
                                            </div>
                                            <div className="col whats-next-overview-container__content">
                                                <Typography
                                                    type={`${isMobileSize ? 'heading-05' : 'heading-06'}`}
                                                >
                                                    Your appointment has been scheduled
                                                </Typography>
                                                <div className="detail-sub-content">
                                                    <Typography
                                                        type="body-02"
                                                    >
                                                        Select the <strong>ADD TO CALENDAR</strong> for reminders of your appointment
                                                    </Typography>
                                                </div>

                                                <OverviewConfirmation
                                                    isMobileSize={isMobileSize}
                                                />
                                                <SchedulingQuestions />
                                            </div>
                                        </div>
                                        {window.serverData.data.enableQualtricsSurveyInHomeScheduling && <div id="bsw_qtx_inhome_schedule"></div>}
                                    </>
                                    : <>
                                        <Notifier
                                            colorStyle="error"
                                            icon="exclamation"
                                            heading="Something went wrong"
                                            link={{
                                                as: <button type="button"></button>,
                                                label: "Try again",
                                                onClick: rebookAppt
                                            }}
                                        >
                                            We were unable to schedule your appointment.
                                        </Notifier>
                                        {pending && <Spinner />}
                                    </>
                                }
                            </div>
                        </div>
                </Grid>
                </>
            }
        </>
    );
}
const mapStateToProps = state => {
    return {
        bookApptResult: state.inHome.bookApptResult,
        pending: state.inHome.bookApptPending,
        screenBreakPoint: state.common.screenBreakPoint
    }
}

const mapDispatchToProps = dispatch => {
    return {
        bookAppointment: () => {
            dispatch({ type: types.BOOK_INHOME_APPT })
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InHomeWhatsNext);